import React, { useState, useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import PageHeader from '../components/ui/PageHeader';
import api from '../services/api';

const progressBar = (value) => ({
  width: `${value}%`, height: 8, borderRadius: 999, background: '#C9A84C',
});

function ProjetsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.projects.getAll()
      .then(res => setProjects(res.projects || []))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const summary = [
    { label: 'Projets actifs', value: projects.filter(p => ['en_cours', 'production'].includes(p.status)).length, color: '#C9A84C' },
    { label: 'À livrer', value: projects.filter(p => p.status === 'production').length, color: '#42a5f5' },
    { label: 'En retard', value: projects.filter(p => p.status === 'retard').length, color: '#ef5350' },
    { label: 'Terminés', value: projects.filter(p => p.status === 'termine').length, color: '#66bb6a' },
  ];

  return (
    <MainLayout>
      <div style={{ display: 'grid', gap: 24 }}>
        <PageHeader title="Projets" subtitle="Suivi des portefeuilles, des statuts et des avancements." />

        {loading && <div style={{ textAlign: 'center', color: '#C9A84C', padding: 20 }}>Chargement…</div>}
        {error && <div style={{ color: '#ef8080', fontSize: 12, padding: '8px 14px', background: 'rgba(239,83,80,.1)', borderRadius: 8 }}>⚠️ {error}</div>}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: 16 }}>
          {summary.map((item) => (
            <div key={item.label} style={{ background: '#0f1724', border: '1px solid rgba(255,255,255,.08)', borderRadius: 18, padding: 20 }}>
              <div style={{ color: item.color, fontSize: 22, marginBottom: 8 }}>•</div>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{item.value}</div>
              <div style={{ fontSize: 12, color: '#94a3b8' }}>{item.label}</div>
            </div>
          ))}
        </div>

        <div style={{ background: '#0f1724', border: '1px solid rgba(255,255,255,.08)', borderRadius: 18, padding: 20 }}>
          <h2 style={{ margin: '0 0 16px' }}>Liste des projets</h2>
          {projects.length === 0 && !loading && (
            <div style={{ textAlign: 'center', color: '#445', padding: 20, fontSize: 13 }}>Aucun projet trouvé.</div>
          )}
          <div style={{ display: 'grid', gap: 14 }}>
            {projects.map((project) => (
              <div key={project.id} style={{ background: '#111f2b', borderRadius: 16, padding: 18, display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', gap: 18 }}>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>{project.name || project.nom}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>
                    {project.owner ? `${project.owner.prenom || ''} ${project.owner.nom || ''}`.trim() : '—'}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 6 }}>{project.status || project.statut}</div>
                  <div style={{ width: 120, background: 'rgba(255,255,255,.06)', borderRadius: 999, height: 8, overflow: 'hidden' }}>
                    <div style={progressBar(project.progress || 0)} />
                  </div>
                  <div style={{ fontSize: 10, color: '#667', marginTop: 4 }}>{project.progress || 0}%</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ProjetsPage;
